import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import LockCircled from 'assets/images/billing/img_lock-circled.svg'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'

const t = buildTranslate('errors')

type PropsT = {
  title?: string
  message?: string
  // AI-1291: the original caller replaces the WHOLE Activity tab, so a
  // full-viewport block is right there. Inside a single panel (the Order
  // feedback tab) 100vh dwarfs the panel it sits in, so that caller opts out
  // and the block sizes to its own content. Defaults to true, leaving the
  // original caller byte-identical.
  fullHeight?: boolean
}

const Forbidden: React.FC<PropsT> = ({
  title = t('forbidden_title'),
  message = t('forbidden_message'),
  fullHeight = true,
}: PropsT) => {
  const [css] = useStyletron()

  return (
    <div
      className={`grey-05-bkg pb-xxl grey-20-border ${css(
        fullHeight ? { height: '100vh' } : {}
      )}`}
    >
      <Container className="pt-xl">
        <div className="text-center">
          <div>
            <img src={LockCircled} alt="lock" width="32" />
          </div>
          <Text.Header4 bold className="mt-m mb-xs grey-90">
            {title}
          </Text.Header4>
          <Text.BodyText3 className="grey70" tag="p">
            {message}
          </Text.BodyText3>
        </div>
      </Container>
    </div>
  )
}

export default Forbidden
